import { FeatureDTO } from "./FeatureDTO";

export class CoursesCatalogFeatureDTO extends FeatureDTO {
    url: string;

    constructor(sub?) {
        super(sub);

        this.url = sub?.url || null;
    }
}
